module.exports = __webpack_public_path__ + "c_static/img/2收藏截图.b1ab466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/2收藏截图.jpg
// module id = gTxh
// module chunks = 33